import { IconButton, HStack, VStack, Stack, Select, Text } from '@genial/components';
import { BoxRadius, Color, BoxBorder } from '@genial/design-tokens';
import React from 'react';

import { InputMoney } from '../../../../../../../components/InputMoney';
import {
  TableContentItemCaptions,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../components/TableContent';
import { mapCaptions } from '../../../../../utils';
import {
  ApplicationInfo,
  FeeInfo,
  MaturityInfo,
  NetValueInfo,
  ProfitabilityInfo,
  RiskInfo,
  TaxInfo,
  UnitPriceInfo,
} from '../../../../DynamicAsset/components/Asset/products/FixedIncome/shared';

import { AddedProductResponsiveItemFixedIncomeProps } from '.';

export const AddedProductItemFixedIncomeTablet: React.FC<
  AddedProductResponsiveItemFixedIncomeProps
> = (props) => {
  const {
    inputMoneyDataProps,
    inputIsFocused,
    messageAdjustUnitPriceIsVisible,
    onRemoveProduct,
    data,
    ableToChangeFees,
    selectedFee,
    selectedFeeId,
    setSelectedFeeId,
    estimatedIncomeCalculated,
    estimatedNetValueCalculated,
  } = props;

  const infosProps = {
    offer: data,
    selectedFee,
    estimatedIncomeCalculated,
    estimatedNetValueCalculated,
  };

  return (
    <VStack w="full" space="stack.xxxs">
      <HStack justifyContent="space-between" w="full">
        <TableContentItemColumn flex={2} space="inline.quarck">
          <TableContentItemText>{data.productDisplayNormalized}</TableContentItemText>
          <TableContentItemCaptions forceDesktop icons={mapCaptions(data)} />
        </TableContentItemColumn>
        <IconButton
          testId="icon-button"
          onPress={onRemoveProduct}
          borderRadius={BoxRadius.sm}
          icon="Trash"
          p={0}
          iconColor={Color['feedback.error.default']}
          iconSize="xs"
        />
      </HStack>
      <HStack w="full">
        <ApplicationInfo w="1/5" {...infosProps} />
        <RiskInfo w="1/5" {...infosProps} />
        <TaxInfo w="1/5" {...infosProps} />
        <ProfitabilityInfo w="1/5" {...infosProps} />
        <MaturityInfo w="1/5" {...infosProps} />
      </HStack>
      <HStack w="full">
        <TableContentItemColumn space="inline.quarck" w="1/4">
          <TableContentItemText>Taxa</TableContentItemText>
          {ableToChangeFees ? (
            <Stack mr="inline.xxxs" bgColor="backgroundshade" borderRadius={BoxBorder.thick}>
              <Select
                testID="fee-select"
                options={data.distributionFeesNormalized.map((feeOption) => ({
                  label: feeOption.label,
                  value: feeOption.feeId.toString(),
                }))}
                placeholder="--"
                selectedValue={selectedFeeId?.toString() || ''}
                onValueChange={(value) => setSelectedFeeId(Number(value))}
              />
            </Stack>
          ) : (
            <TableContentItemText>
              {selectedFee?.customerFeeAmountFormatted || '--'}
            </TableContentItemText>
          )}
        </TableContentItemColumn>
        <UnitPriceInfo w="1/5" {...infosProps} />
        <FeeInfo w="1/5" {...infosProps} />
        <TableContentItemColumn space="inline.quarck" w="1/5">
          <VStack space="stack.quarck" justifyContent="space-between">
            <Text variant="semibold">Valor a aplicar</Text>
            <Stack pr="inline.xxxs">
              <InputMoney {...inputMoneyDataProps} />
              {messageAdjustUnitPriceIsVisible && !inputIsFocused && (
                <TableContentItemText fontSize="xs" color="neutral.light">
                  Ajustado por preço unitário
                </TableContentItemText>
              )}
            </Stack>
          </VStack>
        </TableContentItemColumn>
        <NetValueInfo w="1/5" {...infosProps} />
      </HStack>
    </VStack>
  );
};
